import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AppHeader } from './app-header/app-header.component';
import { AppSidebar } from './app-sidebar/app-sidebar.component';
import { AppFooter } from './app-footer/app-footer.component';
import { FullLayoutComponent } from './full-layout/full-layout.component';
import { ContentLayoutComponent } from './content-layout/content-layout.component';
import { FullHeaderComponent } from './full-header/full-header.component';
import { FullFooterComponent } from './full-footer/full-footer.component';
import { NewlayoutHeaderComponent } from './newlayout-header/newlayout-header.component';
import { NewlayoutContentComponent } from './newlayout-content/newlayout-content.component';
import { NewlayoutFooterComponent } from './newlayout-footer/newlayout-footer.component';

import {CompanyContentComponent} from '../modules/admin/layouts/company-content/company-content.component'
import {CompanyHeaderComponent} from '../modules/admin/layouts/company-header/company-header.component'

import {CompanyLayoutsModule} from '../modules/admin/layouts/company-layouts.module'

import { AvatarModule } from 'ngx-avatar';

@NgModule({
  declarations: [
    AppHeader,
    AppSidebar,
    AppFooter,
    FullLayoutComponent,
    ContentLayoutComponent,
    FullHeaderComponent,
    FullFooterComponent,
    NewlayoutHeaderComponent,
    NewlayoutContentComponent,
    NewlayoutFooterComponent,
    //CompanyHeaderComponent,
    //CompanyContentComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    AvatarModule,
    //CompanyLayoutsModule
  ]
})
export class LayoutsModule { }
